/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ProjectActivityResourcePastEventsInner } from './';
import {
    ProjectActivityResourcePastEventsInnerFromJSON,
    ProjectActivityResourcePastEventsInnerFromJSONTyped,
    ProjectActivityResourcePastEventsInnerToJSON,
} from './';
import type { ProjectActivityResourcePendingActionsInner } from './';
import {
    ProjectActivityResourcePendingActionsInnerFromJSON,
    ProjectActivityResourcePendingActionsInnerFromJSONTyped,
    ProjectActivityResourcePendingActionsInnerToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectActivityResource
 */
export interface ProjectActivityResource {
    /**
     * 
     * @type {Array<ProjectActivityResourcePendingActionsInner>}
     * @memberof ProjectActivityResource
     */
    pendingActions: Array<ProjectActivityResourcePendingActionsInner>;
    /**
     * 
     * @type {Array<ProjectActivityResourcePastEventsInner>}
     * @memberof ProjectActivityResource
     */
    pastEvents: Array<ProjectActivityResourcePastEventsInner>;
}

/**
 * Check if a given object implements the ProjectActivityResource interface.
 */
export function instanceOfProjectActivityResource(value: object): value is ProjectActivityResource {
    if (!('pendingActions' in value) || value['pendingActions'] === undefined) return false;
    if (!('pastEvents' in value) || value['pastEvents'] === undefined) return false;
    return true;
}

export function ProjectActivityResourceFromJSON(json: any): ProjectActivityResource {
    return ProjectActivityResourceFromJSONTyped(json, false);
}

export function ProjectActivityResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectActivityResource {
    if (json == null) {
        return json;
    }
    return {
        
        'pendingActions': ((json['pendingActions'] as Array<any>).map(ProjectActivityResourcePendingActionsInnerFromJSON)),
        'pastEvents': ((json['pastEvents'] as Array<any>).map(ProjectActivityResourcePastEventsInnerFromJSON)),
    };
}

export function ProjectActivityResourceToJSON(value?: ProjectActivityResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'pendingActions': ((value['pendingActions'] as Array<any>).map((v) => ProjectActivityResourcePendingActionsInnerToJSON(v))),
        'pastEvents': ((value['pastEvents'] as Array<any>).map((v) => ProjectActivityResourcePastEventsInnerToJSON(v))),
    };
}

